'use no memo';

import type { Table as TableInstance } from '@tanstack/react-table';

import { ColumnsIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuLabel, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

interface TanstackTableColumnsDropdownProps<TData> {
  table: TableInstance<TData>;
}

export default function TanstackTableColumnsDropdown<TData>(tanstackTableColumnsDropdownProps: TanstackTableColumnsDropdownProps<TData>) {
  const { table } = tanstackTableColumnsDropdownProps;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className={'shrink-0'} size={'md'} variant={'outline'}>
          <ColumnsIcon />
          Kolumny
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={'end'}>
        <DropdownMenuLabel>Wybierz kolumny</DropdownMenuLabel>
        <DropdownMenuGroup>
          {table
            .getAllColumns()
            .filter((column) => typeof column.accessorFn !== 'undefined' && column.getCanHide())
            .map((column) => {
              return (
                <DropdownMenuCheckboxItem
                  key={column.id}
                  className="capitalize"
                  checked={column.getIsVisible()}
                  onCheckedChange={(value) => {
                    column.toggleVisibility(value);
                  }}
                  onSelect={(e) => e.preventDefault()}
                >
                  {column.columnDef.meta?.toString() ?? ''}
                </DropdownMenuCheckboxItem>
              );
            })}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
